import { CommonControllerComponent } from '../util/common.controller';
import { Component } from "@angular/core";
@Component({
	template: `<h3 class="p-3 text-center">Login link Sent</h3>
  <p class="text-center">Check your email to continue logging in</p>`
})
export class OneTimePassword extends CommonControllerComponent {

}
